import axios from 'axios';
export default {
    namespaced: true,
	state: {
		news:null
    },
    getters: {
        getNews(state) {
            return state.news
        },
        getApiUri(state, getters, rootState, rootGetters) {
            return rootGetters['api/getNewsApiUri'];
        }
    },
    mutations: {
        setNews(state,  news) {
            state.news = news;
        }
    },
    actions: {
        requestNews(store, chanel) {
            chanel = store.getters['getApiUri']
            axios.get(chanel, { headers: {
                'Content-type': 'application/json'
              }}).then(response => (store.commit('setNews', response.data.articles)));
        }
    }
}